import {useCreateCorrectiveTaxDocumentV4Mutation} from '@dms/api/finance';
import {accountingRoutes} from '@dms/routes';
import {handleApiError} from '@dms/shared';

import {useNavigate} from 'shared/web';

import {AccountingDocumentFormValues} from '../../../types';
import {useGetCorrectiveTaxDocumentBody} from './useGetCorrectiveTaxDocumentBody';

export const useHandleSubmitCorrectiveTaxDocument = () => {
  const navigate = useNavigate();
  const [createCorrectiveTaxDocument] = useCreateCorrectiveTaxDocumentV4Mutation();
  const [getRequestBody] = useGetCorrectiveTaxDocumentBody();

  const submitCorrectiveTaxDocument = async (formData: AccountingDocumentFormValues) => {
    const correctiveTaxDocumentV4RequestBody = getRequestBody(formData);

    await createCorrectiveTaxDocument({correctiveTaxDocumentV4RequestBody})
      .unwrap()
      .then(() => navigate(accountingRoutes.invoiceOverview))
      .catch(handleApiError);
  };

  return [submitCorrectiveTaxDocument] as const;
};
